// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__2Zvo6","wrapper":"style_wrapper__1oU1J"};